<template>
    <v-container fluid>
      <fulldialog 
        v-if="dialogListar"
        v-bind:ambitos="ambitos" 
        v-bind:tiempoAccion="tiempoAccion" 
        v-bind:gradosurgencia="gradosurgencia" 
        v-bind:clientes="clientes"
        v-bind:comerciales="comerciales"
      />
      <div  v-if="!dialogListar">
        <h1>Nueva acción Masiva</h1>
        <v-card elevation="2" class="mt-4" :loading="loading">
          <v-card-text>
              <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="grupoSelec" :items="grupos" label="Selecciona un grupo" item-text="nombre" return-object prepend-icon="mdi-account-group-outline"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select :items="tiempoAccion" label="Tiempo por acción" v-model="tiempo" prepend-icon="mdi-timer-outline"></v-select>
                  </v-col>
              </v-row>
              <v-row>
              <v-col cols="12" sm="6" class="pt-0">
                <v-dialog ref="dialogFecha" v-model="modalFecha" :return-value.sync="fecha" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field 
                      v-model="fechaFormateada" 
                      prepend-icon="mdi-calendar" 
                      label="Fecha" v-bind="attrs" 
                      v-on="on" 
                      @blur="fecha = parseDate(fechaFormateada)" 
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fecha" scrollable :first-day-of-week="1">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalFecha = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialogFecha.save(fecha)">Aceptar</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="6" class="pt-0">
                <v-dialog ref="dialogHora" v-model="modalHora" :return-value.sync="hora" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="hora" label="Hora" prepend-icon="mdi-clock-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="modalHora" v-model="hora" format="24hr" full-width>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalHora = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialogHora.save(hora)">Aceptar</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="pt-0">
                <v-select :items="ambitos" item-text="ambito" label="Ámbito" v-model="ambito" prepend-icon="mdi-clipboard-text-outline" return-object></v-select>
              </v-col>
              <v-col cols="12" sm="6" class="pt-0">
                <v-select :items="gradosurgencia" item-text="urgencia" label="Urgencia" prepend-icon="mdi-alert-octagon-outline" v-model="gradourgencia" return-object></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0">
                <ArdiContextMenu :contextMenu="contextMenu" align="end" />
                <v-textarea 
                  class="mx-2" 
                  label="Descripción de la intervención" 
                  rows="4" 
                  v-model="descripcion"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" align="end">
                <v-btn color="primary" outlined @click="agruparDatos()" :disabled="this.$v.grupoSelec.$invalid">GENERAR LISTADO</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <ComentariosGuardados 
        :dialogComentariosGuardados="dialogComentariosGuardados" 
        @close="dialogComentariosGuardados = false"
        @aceptar="insertarComentario"
      />
      <ArdiImproveWriting v-if="dialogImproveWriting" :showDialog.sync="dialogImproveWriting" :textToImprove.sync="descripcion" @accept="updateComment" />
    </v-container>
</template>

<script>
import FullDialog from './FullDialog';
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import ComentariosGuardados from '../../comentariosGuardados/ComentariosGuardados.vue'
import axios from 'axios';
import ArdiContextMenu from '@/components/ArdiContextMenu'
import ArdiImproveWriting from '@/components/ArdiImproveWriting'
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'accionesMasivas',
    data: () =>({
      grupos: [],
      headers: [
        {
          text: 'Grupo',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'nombre'
        },
        {
          text: '',
          align: 'right',
          filterable: true,
          sortable: false,
          value: 'tipo'
        }
      ],
      loading: false,
      search: '',
      grupoSelec: {},
      dialogFecha: false,
      modalFecha: false,
      fechaFormateada: null,
      fecha: '',
      modalHora: false,
      hora: '',
      ambitos: [],
      ambito: {},
      tiempoAccion: ['15 minutos', '30 minutos', '45 minutos', '60 minutos'],
      tiempo: '',
      descripcion: '',
      fueraHoras: false,
      clientes: [],
      gradourgencia: {},
      gradosurgencia: [],
      comerciales: [],
      dialogComentariosGuardados: false,
      dialogImproveWriting: false
    }),
    async mounted(){
      this.setLoading(true);
      this.loading = true;
      try{
        let respuesta = await axios.get('/api/gruposaccionesmasivas'); //RECUPERAR GRUPOS BDD
        let gruposPublicos = respuesta.data.filter(g => g.publico == 0);
        let gruposPribasdos = respuesta.data.filter(g => g.publico == 1);
        if(gruposPublicos.length != 0){
          this.grupos.push({ header: 'Grupos privados'});
          gruposPublicos.forEach(grupo => {
            this.grupos.push(grupo);
          });
        }
        if(gruposPribasdos.length != 0){
          if(gruposPublicos.length != 0){ this.grupos.push({ divider: true });}
          this.grupos.push({ header: 'Grupos públicos' });
          gruposPribasdos.forEach(grupo => {
            this.grupos.push(grupo);
          });
        } 

        respuesta = await axios.get("/api/ambitos");//RECUPERAR AMBITOS BDD
        this.ambitos = respuesta.data;

        respuesta = await axios.get("/api/gradosurgencia");//LISTARA GRADO DE URGENCIA BDD
        this.gradosurgencia = respuesta.data;

        this.inicializarDatos();
        this.setLoading(false);
        this.loading = false;
      } catch (error) {
        this.setLoading(false);
        this.loading = false;
        this.setSnackbar({
          tipo: "error",
          mensaje: "Error. No se han podido recuperar los datos",
        });
      }       
    },
    methods: {
      ...mapActions('accionesMasivas', ['setDialogListar', 'setDatosAccion']),
      ...mapActions(['setLoading', 'setSnackbar']),
      inicializarDatos(){
        this.ambito = this.ambitos.filter(a => a.id == 5)[0];
        this.gradourgencia = this.gradosurgencia.filter(g => g.id == 4)[0];
        this.fechaFormateada = this.formatDate(new Date().toISOString().substr(0, 10));
        this.fecha = this.parseDate(this.fechaFormateada);
        this.hora = this.calcularHora();
        this.tiempo = '15 minutos';
        this.descripcion = '';
        this.grupoSelec = {};
        this.fueraHoras = false;
      },
      formatDate (fecha) { //cambiamos el formato de la fecha de YYYY-MM-DD a DD/MM/YYYY
        const [year, month, day] = fecha.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (fecha) { //cambiamos el formato de la fecha de DD/MM/YYYY a YYYY-MM-DD
        const [day, month, year] = fecha.split('/')
        return `${year}-${month}-${day}`
      },
      calcularHora() {
        let hoy = new Date()
        let horas = hoy.getHours() < 10 ? '0' + hoy.getHours() : hoy.getHours()            
        let minutos = ((Math.ceil((hoy.getMinutes() < 10 ? '0'+hoy.getMinutes() : hoy.getMinutes())/5)))*5; //obligo a los minutos a ser multiple de 5
        if(minutos === 60){ //monto la hora en formato hh:mm
          return Number(horas)+1 + ":00"; 
        }else{
          return horas + ":" + (minutos < 10 ? '0' + minutos : minutos);
        }
      },
      agruparDatos(){
        let datos = {
          grupo: this.grupoSelec,
          fecha: this.fechaFormateada,
          hora: this.hora,
          ambito: this.ambito,
          gradourgencia: this.gradourgencia,
          tiempoAccion: this.tiempo,
          descripcion: this.descripcion,
          fueraHoras: this.fueraHoras == null ? false : this.fueraHoras
        }
        
        if(this.grupoSelec.orden_contratos){
          datos.orden_contratos = this.grupoSelec.orden_contratos;
        };
        
        this.setDatosAccion(datos);
        this.obtenerDatosFullDialog();
      },
      async obtenerDatosFullDialog(){
        this.setLoading(true);
        try{
          let respuesta = await axios.get("/api/usuarios?grupo=3"); //LISTAR COMERCIALES BBDD
          this.comerciales = respuesta.data;

          respuesta = await axios.get(`/api/gruposaccionesmasivas/${this.grupoSelec.id}`);//CARGAR CLIENTES CORRESPONDIENTES AL GRUPO CON CONTRATOS Y DELEGACIÓN  
          this.clientes = respuesta.data;

          respuesta = await axios.get('/api/clientes'); //LISTAR TODOS LOS CLIENTES BBDD
          let clientesTodos = respuesta.data;
          
          if(this.clientes.length === 0){
            this.inicializarDatos();
            this.setLoading(false);
            this.setSnackbar({
              tipo: "warning",
              mensaje: "El grupo elegido no consta de clientes",
            });
          }else{
            this.clientes.forEach(cliente => { //Añado al cliente su nombre y su comercial
              let datos =  clientesTodos.filter(c => c.code === cliente.cliente_id);
              if(datos.length > 0){
                cliente.name = datos[0].name;
                cliente.comercialEmail = datos[0].comercialEmail;
              }
            });
            this.setDialogListar(true);
            this.inicializarDatos();
            this.setLoading(false);
          }
        } catch (error) {
          this.setLoading(false);
          this.setSnackbar({
            tipo: "error",
            mensaje: "Error. No se han podido recuperar los datos",
          });
        }
      },
      insertarComentario(comentarios){
        if(this.descripcion === null) this.descripcion = ''
        if(this.descripcion.length > 0) this.descripcion += '\n'
        comentarios.forEach((comentario, index, comentarios) => {
            this.descripcion += comentario.texto
            if(index < comentarios.length-1){
                this.descripcion += '\n'
            }
        });
        this.dialogComentariosGuardados = false
      },
      updateComment(improvedComment){
        this.descripcion = improvedComment
      },
      abrirDialogComentariosGuardados(){
        this.dialogComentariosGuardados = true
      },
      abrirDialogMejorarEscritura(){
        this.dialogImproveWriting = true
      }
    },
    validations: {
      grupoSelec: { required }
    },
    watch: {
      fecha (val) {
        this.fechaFormateada = this.formatDate(this.fecha)
      },
    },
    computed: {
      ...mapState('accionesMasivas', ['dialogListar', 'datosAccion']),
      contextMenu() {
        return [
          {
            title: 'Comentarios guardados',
            icon: 'mdi-playlist-star',
            color: 'default',
            event: this.abrirDialogComentariosGuardados
          },
          {
            title: 'Mejorar escritura',
            icon: 'mdi-text',
            color: 'default',
            showIaLabel: true,
            disabled: !this.descripcion?.trim(),
            event: this.abrirDialogMejorarEscritura
          }
        ]
      }
    },
    components: {
      'fulldialog': FullDialog,
      ComentariosGuardados,
      ArdiContextMenu,
      ArdiImproveWriting
    },
}
</script>
<style>
    
</style>